const relationshipRoles = [
  // 👨‍👩‍👧 Core Family
  { keyword: 'mother', aliases: ['mom', 'mum'], role: 'mother', gender: 'female', priority: 1 },
  { keyword: 'father', aliases: ['dad', 'pop', 'papa'], role: 'father', gender: 'male', priority: 1 },
  { keyword: 'parent', aliases: ['parents'], role: 'parent', gender: 'neutral', priority: 1 },
  { keyword: 'daughter', aliases: [], role: 'daughter', gender: 'female', priority: 1 },
  { keyword: 'son', aliases: [], role: 'son', gender: 'male', priority: 1 },
  { keyword: 'child', aliases: ['children'], role: 'child', gender: 'neutral', priority: 1 },
  { keyword: 'sister', aliases: ['sis'], role: 'sister', gender: 'female', priority: 2 },
  { keyword: 'brother', aliases: ['bro'], role: 'brother', gender: 'male', priority: 2 },

  // 👵 Extended Family
  { keyword: 'aunt', aliases: [], role: 'aunt', gender: 'female', priority: 3 },
  { keyword: 'uncle', aliases: [], role: 'uncle', gender: 'male', priority: 3 },
  { keyword: 'grandmother', aliases: ['grandma', 'nana', 'granny'], role: 'grandmother', gender: 'female', priority: 3 },
  { keyword: 'grandfather', aliases: ['grandpa', 'gramps', 'pop-pop'], role: 'grandfather', gender: 'male', priority: 3 },
  { keyword: 'grandparent', aliases: ['grandparents'], role: 'grandparent', gender: 'neutral', priority: 3 },
  { keyword: 'granddaughter', aliases: [], role: 'granddaughter', gender: 'female', priority: 3 },
  { keyword: 'grandson', aliases: [], role: 'grandson', gender: 'male', priority: 3 },
  { keyword: 'grandchild', aliases: ['grandchildren'], role: 'grandchild', gender: 'neutral', priority: 3 },
  { keyword: 'niece', aliases: [], role: 'niece', gender: 'female', priority: 3 },
  { keyword: 'nephew', aliases: [], role: 'nephew', gender: 'male', priority: 3 },
  { keyword: 'cousin', aliases: [], role: 'cousin', gender: 'neutral', priority: 3 },

  // ❤️ Romantic & Former
  { keyword: 'wife', aliases: [], role: 'spouse', gender: 'female', priority: 1 },
  { keyword: 'husband', aliases: [], role: 'spouse', gender: 'male', priority: 1 },
  { keyword: 'partner', aliases: ['spouse'], role: 'partner', gender: 'neutral', priority: 1 },
  { keyword: 'girlfriend', aliases: [], role: 'girlfriend', gender: 'female', priority: 2 },
  { keyword: 'boyfriend', aliases: [], role: 'boyfriend', gender: 'male', priority: 2 },
  { keyword: 'fiance', aliases: ['fiancé'], role: 'fiance', gender: 'male', priority: 2 },
  { keyword: 'fiancee', aliases: ['fiancée'], role: 'fiancee', gender: 'female', priority: 2 },
  { keyword: 'ex-wife', aliases: [], role: 'ex-wife', gender: 'female', priority: 2 },
  { keyword: 'ex-husband', aliases: [], role: 'ex-husband', gender: 'male', priority: 2 },
  { keyword: 'ex-girlfriend', aliases: [], role: 'ex-girlfriend', gender: 'female', priority: 2 },
  { keyword: 'ex-boyfriend', aliases: [], role: 'ex-boyfriend', gender: 'male', priority: 2 },

  // 🤝 Social
  { keyword: 'friend', aliases: ['buddy', 'pal', 'best friend'], role: 'friend', gender: 'neutral', priority: 2 },
  { keyword: 'roommate', aliases: ['room mate'], role: 'roommate', gender: 'neutral', priority: 3 },
  { keyword: 'neighbor', aliases: ['neighbour'], role: 'neighbor', gender: 'neutral', priority: 3 },

  // 💼 Work / Professional / Care
  { keyword: 'coworker', aliases: ['co-worker', 'coworkers', 'co-workers', 'colleague', 'colleagues'], role: 'coworker', gender: 'neutral', priority: 3 },
  { keyword: 'boss', aliases: ['manager', 'supervisor'], role: 'boss', gender: 'neutral', priority: 3 },
  { keyword: 'employee', aliases: ['employees', 'team member', 'teammate'], role: 'employee', gender: 'neutral', priority: 3 },
  { keyword: 'doctor', aliases: ['physician'], role: 'doctor', gender: 'neutral', priority: 4 },
  { keyword: 'caregiver', aliases: ['carer'], role: 'caregiver', gender: 'neutral', priority: 4 },
  { keyword: 'vet', aliases: ['veterinarian'], role: 'vet', gender: 'neutral', priority: 4 },

  // 🐾 Pets
  { keyword: 'dog', aliases: ['puppy', 'pupper'], role: 'dog', gender: 'n/a', priority: 4 },
  { keyword: 'cat', aliases: ['kitty', 'kitten'], role: 'cat', gender: 'n/a', priority: 4 },
  { keyword: 'pet', aliases: [], role: 'pet', gender: 'n/a', priority: 4 },
];

export default relationshipRoles;
